import { useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const PaymentCancelPage = () => {
  const [searchParams] = useSearchParams();
  const bookingType = searchParams.get("booking_type") || "service";
  const bookingId = searchParams.get("booking_id");

  // Map booking type to route
  const getBookingRoute = () => {
    const routes = {
      cargo: "/cargo",
      courier: "/courier",
      towing: "/towing",
      movers: "/movers",
      haulhitch: "/haulhitch",
      helpers: "/laborer",
    };
    return routes[bookingType] || "/";
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />

      <section className="pt-32 pb-20">
        <div className="section-container">
          <div className="max-w-lg mx-auto">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              className="glass-card p-8 text-center"
            >
              <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-10 h-10 text-amber-600" />
              </div>
              <h1 className="heading-3 text-emerald-950 mb-4">Payment Cancelled</h1>
              <p className="text-stone-600 mb-8">
                Your {bookingType} booking payment was cancelled. No charges have been made.
              </p>

              <div className="bg-stone-100 rounded-2xl p-6 mb-8">
                <p className="text-sm text-stone-600 mb-2">Your booking details have been saved.</p>
                <p className="text-sm text-stone-600">
                  You can return to complete your booking anytime.
                </p>
              </div>

              <div className="flex flex-col gap-3">
                <Link to={getBookingRoute()}>
                  <Button className="btn-primary w-full">
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Return to Booking
                  </Button>
                </Link>
                <Link to="/">
                  <Button variant="outline" className="btn-outline w-full">
                    Back to Home
                  </Button>
                </Link>
              </div>

              <div className="mt-8 pt-6 border-t border-stone-200">
                <p className="text-sm text-stone-500 flex items-center justify-center gap-2">
                  <Phone className="w-4 h-4" />
                  Need help? Call 905-431-0103
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PaymentCancelPage;
